<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>
    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">{{ esNueva ? 'Nueva Comunicación' : 'Detalle de Comunicación' }}</h1>
    </div>
  </div>

  <div class="row-cols-12 m-2 mt-0">
    <div class="row p-3 mb-0 align-items-center">
      <div class="mb-3 mt-0 text-start">

        @if (esNueva) {
          <form (ngSubmit)="enviarComunicacion()" [formGroup]="comunicacionForm">

            <div class="mb-4 mt-2 text-start">
              <label for="titulo" class="form-label"><b>Título</b></label>
              <input
                type="text"
                class="form-control"
                id="titulo"
                formControlName="titulo"
                placeholder="Ingrese un título"
              />
            </div>

            <div class="mb-4 mt-2 text-start">
              <label for="descripcion" class="form-label"><b>Mensaje</b></label>
              <textarea
                class="form-control"
                id="descripcion"
                rows="4"
                formControlName="descripcion"
                placeholder="Ingrese el mensaje de la comunicación"
              ></textarea>
            </div>

            <div class="mb-4 mt-2 text-start">
              <label for="alcance" class="form-label"><b>Alcance</b></label>
              <select
                id="alcance"
                class="form-select"
                formControlName="alcance"
                (change)="onAlcanceChange()"
              >
                <option value="" disabled>Seleccione</option>
                @for (a of alcances; track a.id) {
                  <option [value]="a.id">{{ a.label }}</option>
                }
              </select>
            </div>

            @if (comunicacionForm.controls.alcance.value === 'usuario') {
              <div class="mb-4 mt-2 text-start">
                <label for="usuarioDestino" class="form-label"><b>Usuario destino</b></label>

                <div class="search-select">
                  <input
                    type="search"
                    id="usuarioDestino"
                    class="form-control search-select-input"
                    placeholder="Buscar por email o documento"
                    [value]="usuarioDestinoSearch()"
                    (focus)="showUsuariosList.set(true)"
                    (input)="onUsuarioDestinoInput($any($event.target).value)"
                  />

                  @if (showUsuariosList()) {
                    <div class="search-select-list">
                      @for (usuario of usuariosFiltrados(); track usuario.id) {
                        <button
                          type="button"
                          class="search-select-item"
                          (click)="selectUsuarioDestino(usuario)"
                        >
                          <span>{{ usuario.x_email }}</span>
                          <i class="bi bi-chevron-right"></i>
                        </button>
                      }

                      @if (usuarioDestinoSearch() && usuariosFiltrados().length === 0) {
                        <div class="search-select-empty">
                          No se encontraron usuarios
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }

            <div class="mb-4 mt-2 text-start">
              <label for="appDestino" class="form-label"><b>Destino</b></label>
              <select
                id="appDestino"
                class="form-select"
                formControlName="appDestino"
              >
                @for (a of appsDestino; track a.id) {
                  <option [value]="a.id">{{ a.label }}</option>
                }
              </select>
            </div>

            <div class="mb-4 mt-2 text-start">
              <label class="form-label mb-0"><b>Imagen (opcional)</b></label>

              @if (preview_img(); as img) {
                <div class="d-flex align-items-center mt-2">
                  <img [src]="img" alt="Imagen de la comunicación" class="comunicacion-preview-img" />
                  <button type="button" class="btn-quitar-imagen ms-3" (click)="quitarImagen()">
                    <i class="bi bi-trash"></i> Quitar
                  </button>
                </div>
              } @else {
                <div class="d-grid mt-2">
                  <button type="button" class="btn-cargar-imagen" (click)="capturarImagen()">
                    <i class="bi bi-image"></i> Cargar imagen
                  </button>
                </div>
              }
            </div>

            <div class="form-check form-switch mb-4 mt-4">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                id="enviaEmail"
                formControlName="enviaEmail"
              />
              <label class="form-check-label" for="enviaEmail">
                Enviar también por email
              </label>
            </div>

            @if (error(); as err) {
              @if (err.length > 0) {
                <div class="alert alert-danger mt-2" role="alert">
                  <small>{{ err }}</small>
                </div>
              }
            }

            <div class="d-grid mt-5 mb-3 pb-3">
              <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading()">
                {{ loading() ? 'Enviando...' : 'Enviar Comunicación' }}
              </button>
            </div>

          </form>
        } @else if (comunicacion(); as c) {

          <div class="mb-2">
            <span class="badge-alcance">{{ getAlcanceLabel(c.x_alcance) }}</span>
            <span class="badge-alcance">{{ getAppDestinoLabel(c.x_app) }}</span>
          </div>

          <h2 class="comunicacion-detalle-titulo mt-2">{{ c.x_titulo }}</h2>

          @if (getImgUrl(c.x_img); as img) {
            <img [src]="img" alt="Imagen de la comunicación" class="comunicacion-preview-img mt-2 mb-2" />
          }

          <p class="comunicacion-detalle-descripcion">{{ c.x_descripcion }}</p>

          <div class="comunicacion-detalle-datos mt-4">
            <div class="row-detalle">
              <span class="label">Fecha</span>
              <span>{{ c.d_fecha | date:'dd/MM/yyyy HH:mm' }}</span>
            </div>
            <div class="row-detalle">
              <span class="label">Enviada por</span>
              <span>{{ c.x_admin_email }}</span>
            </div>
            @if (c.x_alcance === 'usuario') {
              <div class="row-detalle">
                <span class="label">Destinatario</span>
                <span>{{ c.x_destino_email }}</span>
              </div>
            }
            <div class="row-detalle">
              <span class="label">Enviada por email</span>
              <span>{{ c.b_envia_email ? 'Sí' : 'No' }}</span>
            </div>
            <div class="row-detalle">
              <span class="label">Destinatarios</span>
              <span>{{ c.n_enviados_ok ?? 0 }}/{{ c.n_destinatarios ?? 0 }} enviados</span>
            </div>
            <div class="row-detalle">
              <span class="label">Lectura</span>
              @if ((c.n_destinatarios ?? 0) === 1) {
                <span>{{ (c.n_leidos ?? 0) > 0 ? 'Leído' : 'No leído' }}</span>
              } @else {
                <span>{{ c.n_leidos ?? 0 }} de {{ c.n_destinatarios ?? 0 }} destinatarios lo leyeron</span>
              }
            </div>
          </div>

          @if (error(); as err) {
            @if (err.length > 0) {
              <div class="alert alert-danger mt-4" role="alert">
                <small>{{ err }}</small>
              </div>
            }
          }
        }

      </div>
    </div>
  </div>
</div>
